import { actionTypes } from "./action-types";
import { mutationTypes } from "./mutation-types";
import { getterTypes } from "./getter-types";
import { validateMessages } from "@/config";
import {
  fetchPaymentMethods,
  fetchShippingMethods,
  checkoutAddress,
  chooseShippingMethod,
  choosePaymentMethod,
  completeCheckout,
  orderInfo,
  paymentPath,
  paymentInfo,
  orders
} from "@/services/order";

const OrderModule = {
  namespaced: true,
  strict: true,
  state: {
    paymentMethods: [],
    shippingMethods: [],
    shippmentMethod: null,
    checkoutAddress: null,
    paymentMethod: null,
    completedCheckout: null,
    orderInfo: null,
    paymentInfo: null,
    orders: [],
  },
  actions: {
    [actionTypes.FETCH_PAYMENT_METHODS]({ commit }) {
      return new Promise((resolve, reject) => {
        fetchPaymentMethods()
          .then((response) => {
            commit(mutationTypes.SET_PAYMENT_METHODS, response.data);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.FETCH_SHIPPING_METHODS]({ commit }) {
      return new Promise((resolve, reject) => {
        fetchShippingMethods()
          .then((response) => {
            commit(mutationTypes.SET_SHIPPING_METHODS, response.data);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.ADD_CHECKOUT_ADDRESS]({ commit }, data) {
      return new Promise((resolve, reject) => {
        checkoutAddress(data)
          .then((response) => {
            commit(mutationTypes.SET_CHECKOUT_ADDRESS, response.data);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.ADD_SHIPPMENT_METHOD]({ commit }, data) {
      return new Promise((resolve, reject) => {
        chooseShippingMethod(data)
          .then((response) => {
            commit(mutationTypes.SET_SHIPPMENT_METHOD, data.method);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.ADD_PAYMENT_METHOD]({ commit }, data) {
      return new Promise((resolve, reject) => {
        choosePaymentMethod(data)
          .then((response) => {
            commit(mutationTypes.SET_PAYMENT_METHOD, data.method);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.ADD_COMPLETE_CHECKOUT]({ commit }, data) {
      return new Promise((resolve, reject) => {
        completeCheckout(data)
          .then((response) => {
            commit(mutationTypes.SET_COMPLETE_CHECKOUT, true);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.ADD_ORDER_INFO]({ commit }, token) {
      return new Promise((resolve, reject) => {
        orderInfo(token)
          .then((response) => {
            commit(mutationTypes.SET_ORDER_INFO, response.data);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.PAY_FOR_ORDER](_, token) {
      return new Promise((resolve, reject) => {
        paymentPath(token)
            .then((response) => {
              console.log(response)
              resolve(response.data);
            })
            .catch((error) => {
              console.log(error);
              reject(validateMessages.error);
            });
      });
    },
    [actionTypes.ADD_PAYMENT_INFO]({ commit }, token) {
      return new Promise((resolve, reject) => {
        paymentInfo(token)
            .then((response) => {
              commit(mutationTypes.SET_PAYMENT_INFO, response.data);
              resolve(response.data);
            })
            .catch(() => {
              reject(validateMessages.error);
            })
      })
    },
    [actionTypes.ADD_ORDERS]({ commit }) {
      return new Promise((resolve, reject) => {
        orders()
          .then((response) => {
            commit(mutationTypes.SET_ORDERS, response.data);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
  },
  mutations: {
    [mutationTypes.SET_PAYMENT_METHODS](state, payload) {
      state.paymentMethods = payload;
    },
    [mutationTypes.SET_SHIPPING_METHODS](state, payload) {
      state.shippingMethods = payload;
    },
    [mutationTypes.SET_CHECKOUT_ADDRESS](state, payload) {
      state.checkoutAddress = payload;
    },
    [mutationTypes.SET_SHIPPMENT_METHOD](state, payload) {
      state.shippmentMethod = payload;
    },
    [mutationTypes.SET_PAYMENT_METHOD](state, payload) {
      state.paymentMethod = payload;
    },
    [mutationTypes.SET_COMPLETE_CHECKOUT](state, payload) {
      state.completedCheckout = payload;
    },
    [mutationTypes.SET_ORDER_INFO](state, payload) {
      state.orderInfo = payload;
    },
    [mutationTypes.SET_PAYMENT_INFO](state, payload) {
      state.paymentInfo = payload.data;
    },
    [mutationTypes.SET_ORDERS](state, payload) {
      state.orders = payload;
    },
  },
  getters: {
    [getterTypes.GET_PAYMENT_METHODS](state) {
      return state.paymentMethods;
    },
    [getterTypes.GET_SHIPPING_METHODS](state) {
      return state.shippingMethods;
    },
    [getterTypes.GET_CHECKOUT_ADDRESS](state) {
      return state.checkoutAddress;
    },
    [getterTypes.GET_SHIPPMENT_METHOD](state) {
      return state.shippmentMethod;
    },
    [getterTypes.GET_PAYMENT_METHOD](state) {
      return state.paymentMethod;
    },
    [getterTypes.GET_COMPLETE_CHECKOUT](state) {
      return state.completedCheckout;
    },
    [getterTypes.GET_ORDER_INFO](state) {
      return state.orderInfo;
    },
    [getterTypes.GET_PAYMENT_INFO](state) {
      return state.paymentInfo;
    },
    [getterTypes.GET_ORDERS](state) {
      return state.orders;
    },
  },
};

export { OrderModule };
